import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

let currentSite = "";
export const setSite = (slug) => {
  currentSite = slug || "";
};
export const getSite = () => currentSite;

api.interceptors.request.use((config) => {
  if (currentSite) config.headers["X-Site"] = currentSite;
  return config;
});

export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || e?.message || "Something went wrong";
};

export const money = (v, currency = "ZAR") =>
  new Intl.NumberFormat("en-ZA", { style: "currency", currency, maximumFractionDigits: 0 }).format(v || 0);

export const toCriteria = ({ hotel_name, ...c }) => c;

export const copyText = async (text, toast) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success("Copied");
  } catch {
    toast.error("Could not copy. Select the text and copy it manually.");
  }
};
